import { Box, Typography, useMediaQuery } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import LocationPinBlueIcon from '../../resources/LocationPinBlue.svg'
import theme from '../../theme'

interface HeaderContentProps {
  storedLocation: { name: string }
  useMoovyKeyboard: boolean
}

const HeaderContent = ({
  storedLocation,
  useMoovyKeyboard
}: HeaderContentProps) => {
  const intl = useIntl()
  const isTabletSize = useMediaQuery(theme.breakpoints.between('md', 'lg'))
  const isLaptopSize = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <Box
      sx={{
        display: 'flex',
        width: { xs: 300, sm: 400 }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: 'column',
          textAlign: 'center',
          mt: '20px',

          ...(useMoovyKeyboard &&
            isTabletSize && {
              '@media (orientation: landscape)': {
                flexDirection: 'row',
                textAlign: 'left',
                alignItems: 'flex-start',
                marginLeft: '5px'
              }
            }),

          ...(isLaptopSize && {
            flexDirection: 'column',
            textAlign: 'center',
            alignItems: 'center'
          })
        }}
      >
        <Box
          component="img"
          alt="Moovy logo"
          src={LocationPinBlueIcon}
          sx={{
            mt: 1,
            alignSelf: 'center',

            ...(useMoovyKeyboard &&
              isTabletSize && {
                '@media (orientation: landscape)': {
                  alignSelf: 'flex-start'
                }
              }),

            ...(isLaptopSize && {
              alignSelf: 'center'
            })
          }}
        />

        <Box sx={{ maxWidth: '400px' }}>
          <Typography
            variant="h1"
            aria-label="Location"
            sx={{
              color: 'primary.main',
              textTransform: 'uppercase'
            }}
          >
            {storedLocation.name || 'Welcome'}
          </Typography>

          <Typography
            variant="h2"
            aria-label="Parking info"
            sx={{
              color: 'text.primary',
              mt: 1
            }}
          >
            <FormattedMessage id="page.homePage.instructions.parkingInfo.default" />
          </Typography>

          <Typography
            variant="body1"
            aria-label={intl.formatMessage({
              id: 'page.homePage.instructions.visitorMessage.organization.arialabel'
            })}
            sx={{
              color: 'text.primary',
              mt: 1,
              mb: 1
            }}
          >
            <FormattedMessage id="page.homePage.instructions.visitorMessage.default" />
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default HeaderContent
